export default __webpack_public_path__ + "3180634c41c6cdb47a4faa71523a16cd.png";